// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import '../static/css/init.css';
import '../src/assets/css/icon/iconfont.css';
import http from './http/http';
import api from './http/api';

Vue.prototype.$http = http;
Vue.prototype.$api = api;

Vue.config.productionTip = false

import 'element-ui/lib/theme-chalk/index.css'
import element from './assets/css/element/index'
Vue.use(element)

import './assets/css/element/ele.css';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js